import WebFont from 'webfontloader';

const closeButton = document.querySelector('.alert span');

if (closeButton) {
    closeButton.onclick = () => {
        document.querySelector('.alert').classList.add('alert-closed');
        document.querySelector('.alert-spacer').classList.add('alert-closed');
    }
}

const primaryNav = document.querySelector('.primary-nav');

document.querySelector('.mobile-nav a').onclick = (event) => {
    event.preventDefault();
    primaryNav.classList.toggle('primary-nav-open');
}

WebFont.load({
    google: {
        families: ['Lato:400,700']
    }
});
